@use '@terminal/components/tooltip-container/shared-tooltip-styles' as *;

.root {
  width: auto;
  overflow-wrap: break-word;
  overflow: visible;
  white-space: normal;
  font-family: var(--font-nort);
}

.styledSpan {
  @include underline-text-styles;

  position: relative;
  left: 8px;
}
